var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFsl2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1385 0H31.2277L20.1092 12.7077L33.1892 30H22.9477L14.9262 19.5123L5.74769 30H0.655385L12.5477 16.4077L0 0H10.5015L17.7523 9.58615L26.1385 0ZM24.3523 26.9538H27.1723L8.96923 2.88615H5.94308L24.3523 26.9538Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsl2);
export default __webpack_public_path__ + "static/media/fsl2.bd22aa77ce423d5ff3bd89d9cb7e0488.svg";
export { ForwardRef as ReactComponent };